import { ScrollArea as MantineScrollArea, ScrollAreaFactory } from "@mantine/core";
import { IProps } from "./scroll-area.types";
import { componentWrapper } from "../../utilities";

const ScrollArea = componentWrapper<ScrollAreaFactory, IProps>("ScrollArea", (props, ref) => {
    return <MantineScrollArea ref={ref} {...props} />;
});

ScrollArea.Autosize = MantineScrollArea.Autosize;

export { ScrollArea };
